import React, { ChangeEvent, useEffect, useState } from 'react'
import { useSearchStore } from '@/shared/store/useSearchStore'
import { useAppStore, useTVStore } from '@/shared/store'
import { useLocation } from 'react-router-dom'

export const useSearchBarLogic = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const { searchValue, setSearchValue } = useSearchStore()
    const { isUserLoggedIn } = useAppStore()
    const { channelsData } = useTVStore()
    const location = useLocation()

    const open = Boolean(anchorEl)
    const id = open ? 'simple-popover' : undefined

    const handlePopperClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        if (!open && searchValue) {
            setAnchorEl(event.currentTarget)
        } else {
            setAnchorEl(null)
        }
    }

    const handlePopperClose = () => {
        setAnchorEl(null)
    }

    const handleInputChange = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { value } = event.target
        setSearchValue(value)
        if (value && !open) {
            setAnchorEl(event.currentTarget)
        }
    }

    useEffect(() => {
        setSearchValue('')
    }, [setSearchValue, location])

    return {
        handlePopperClick,
        handlePopperClose,
        handleInputChange,
        anchorEl,
        searchValue,
        setSearchValue,
        channelsData,
        open,
        id,
        isUserLoggedIn,
    }
}
